// Карта не поддерживает значения lat > 90 и < - 90, поэтому если выходим за границу,
// то принимаем максимальное и минмальное значение
// с lng такой проблемы нет, она спокойно может выходит за 180 градусов, карта дублируется по горизонтали

export const validateLatValue = ({
  lat,
  lng
}: {
  lat: number;
  lng: number;
}) => {
  return {
    lng,
    lat: lat > 90 ? 90 : lat < -90 ? -90 : lat
  };
};
